<div class="row">
    <div class="col-sm-12 col-md-10 col-lg-9 mx-auto">
        <mat-card class="simple-card mx-auto mb-5">
          <mat-card-content>
            <div class="row mb-3 px-3">
                <div class="col-12">
                    <h1>Configuración de MFA</h1>
                </div>
                <div class="col-12 mt-3">
                    <span>
                        Protege tu cuenta vinculando una aplicación de autenticación como Google Authenticator o Authy.
                    </span>
                </div>
                <div class="col-12 mb-3">
                    <span class="font-italic">
                        Puedes revisar <a href="https://aws.amazon.com/es/iam/features/mfa/?audit=2019q1" target="_blank">aquí</a> la lista de aplicaciones compatibles.
                    </span>
                </div>
        
                <div class="col-12 mt-3">
                    <mat-card class="rounded-card">
                        <mat-card-header *ngIf="!showMessage">
                            <mat-card-title class="font-size-title-card">
                                <div class="row">
                                    <div class="col-12">
                                        <strong>Configura tu autenticación en dos pasos (MFA)</strong>
                                    </div>
                                    <div class="col-12 mt-2">
                                        <div class="d-flex align-items-center flex-wrap">
                                            <mat-icon class="text-warning mr-3">error</mat-icon>
                                            <span class="span-title d-inline">Esta configuración reemplazará cualquier autenticador que tengas actualmente vinculado a tu cuenta.</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="row mt-5" *ngIf="!showMessage && showSetup">
                                <div class="col-11 mx-auto">
                                    <form [formGroup]="form" (ngSubmit)="verifyCode()" class="row">
                                        <div class="col-12">
                                            <mat-chip class="chip-info mr-3"><strong>I</strong></mat-chip>
                                            <strong>Escanea este código QR con tu app de autenticación</strong>
                                        </div>
                                        <div class="col-11 mx-auto mt-2">
                                            <span>
                                                Abre una aplicación como Google Authenticator o Authy en tu celular y escanea el siguiente código QR.
                                            </span>
                                        </div>
                                        <div class="col-11 mx-auto font-italic">
                                            <span>
                                                Esto permitirá que la app genere los códigos que necesitarás para ingresar de forma segura.
                                            </span>
                                        </div>
                                        <div class="col-10 mx-auto d-flex align-items-start mt-3">
                                            <div class="row">
                                                <div class="col">
                                                    <img *ngIf="qrCodeDataUrl" [src]="qrCodeDataUrl" alt="Código QR">
                                                </div>
                                                <div class="col">
                                                    <button mat-fab aria-label="Boton recarga de configuracion de mfa" class="custom-button-primary mt-4" type="button" (click)="resetPage()"> <!--(click)="actualizarTabla()"-->
                                                        <i class="fa fa-refresh icon-font" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="col-11 mx-auto mt-3">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="d-flex align-items-center flex-wrap">
                                                        <mat-icon class="text-secondary mr-3">live_help</mat-icon>
                                                        <span>
                                                            ¿No puedes escanear el código QR? Ingresa este código manualmente en tu aplicación:
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-12 ml-5">
                                                    <pre class="text-wrap bg-white text-dark border-0" style="word-break: break-word;">
                                                        {{ sharedSecret || 'Error al obtener el código secreto' }}
                                                    </pre>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="col-12 mt-5">
                                            <mat-chip class="chip-info mr-3"><strong>II</strong></mat-chip>
                                            <strong>Ingresa el código de 6 dígitos</strong>
                                        </div>
        
                                        <div class="col-11 mx-auto mt-2">
                                            <span>
                                                Abre tu aplicación de autenticación y escribe el código que aparece. Este cambia cada 30 segundos.
                                            </span>
                                        </div>
                                        <div class="col-10 mx-auto d-flex align-items-start mt-3">
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field appearance="outline">
                                                        <input matInput placeholder="Ingresa el código aquí" formControlName="codigo" id="codigo">
                                                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearForm()" *ngIf="form.get('codigo')?.value">
                                                            <mat-icon>close</mat-icon>
                                                        </button>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-3 mb-5 d-flex justify-content-center">
                                            <button mat-flat-button 
                                                class="custom-button-tertiary"
                                                type="submit"
                                                >
                                                <mat-icon 
                                                    aria-hidden="false" 
                                                    aria-label="Icono de check" 
                                                    fontIcon="check_small" 
                                                    class="icon-download"
                                                ></mat-icon>
                                                Activar verificación en dos pasos
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
        
                            <div class="row mt-5" *ngIf="showMessage">
                                <div class="col-12 mb-3 d-flex justify-content-center mx-auto height-icon-container">
                                    <mat-icon class="icon-done">check_circle</mat-icon>
                                </div>
                                <div class="col-12 mb-3 d-flex justify-content-center mx-auto">
                                    <span class="span-done-message">
                                        MFA Configurado Correctamente
                                    </span>
                                </div>
                                <!--<div class="col-12 mb-5 d-flex justify-content-center mx-auto">
                                    <button mat-flat-button class="custom-button-secondary" type="button" (click)="resetPage()">
                                        Volver a configurar
                                    </button>
                                </div>-->
                            </div>
        
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
          </mat-card-content>
        </mat-card>
    </div>
</div>